import { ref, type Ref, type VNode } from 'vue';

export class Modal {
  static readonly modals: Ref<Map<number, Modal>> = ref(new Map());

  static closeAll(): void {
    Modal.modals.value.clear();
  }

  static closeTopModal(): void {
    Modal.modals.value.delete(Modal.modals.value.size - 1);
  }

  constructor(public vnode?: VNode) {}

  private _onClose: (() => void)[] = [];

  onClose(cb: () => void): void {
    this._onClose.push(cb);
  }

  open(vnode?: VNode): void {
    if (vnode) {
      this.vnode = vnode;
    }
    if (!this.vnode) {
      throw new Error('Cannot open Modal without VNode');
    }
    const index = Modal.modals.value.size;
    this.onClose(() => {
      Modal.modals.value.delete(index);
    });
    Modal.modals.value.set(index, this);
  }

  close(): void {
    this._onClose.forEach((cb) => cb());
  }
}
